export default __webpack_public_path__ + "static/media/icons8-send-email-96.48329709.svg";